import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {
  BokkzAlgDataService,
  BokkzClient,
  BokkzUitstelDataService,
  ClientEntity,
  UitstelGegevens,
} from '@snelstart-ventures/fiscaal/domain-logic';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {ToastService} from '@snelstart/ui-toast';
import {SharedUiTableModule, TableConfiguration, ZeroStateConfiguration} from '@snelstart/ui-table';
import {SearchCriteria, SearchResult} from '@snelstart/domain-logic';
import {Observable, Subject, switchMap, takeUntil} from 'rxjs';
import {CommonModule, DatePipe} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-uitstel-list',
  templateUrl: './feature-tax-uitstel-list.component.html',
  styleUrl: './feature-tax-uitstel-list.component.scss',
  imports: [SharedUiTableModule, DatePipe, CommonModule],
})
export class FeatureTaxUitstelListComponent implements OnInit, OnDestroy {

  @Output() public details = new EventEmitter<string>();
  protected tableConfig!: TableConfiguration<SearchCriteria, UitstelGegevens>;
  protected clientId: any;
  private destroy$ = new Subject<void>();
  public taxId: any;
  public clientEntity = {} as ClientEntity;
  public dialogVisible = false;
  public showTable = false;
  public datumAutomatischeAanvraag = new Date('2025-04-22') > new Date(new Date().toDateString());
  public year = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzUitstelDataService,
    public bokkzClient: BokkzClient,
    public toastService: ToastService,
    public fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.clientId = params['clientId'];
      this.bokkzClient.getClient(this.clientId).pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.algDataService.updateClient(value);
        this.clientEntity = value;
        this.taxId = value.taxId;
      });
    });
    this.algDataService.selectedYear.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.year = value;
      this.showTable = false;
      setTimeout(() => {
        this.createTableConfig(this.year);
        this.showTable = true;
      }, 0);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private createTableConfig(year: number): void {
    const criteria = new SearchCriteria();
    this.tableConfig = TableConfiguration.create<SearchCriteria, UitstelGegevens>({
      identifier: 'fiscaalNummer',
      options: {
        useSearch: true,
        useSort: true,
      },
        criteria: {take: 25, skip: 0, sortDescending: true},
        search: (criteria) => {
            return this.bokkzClient.getPostponement(year).pipe(
                switchMap(response => {
                    if (!response) {
                        return new Observable<SearchResult<UitstelGegevens>>(subscriber => {
                            subscriber.next(new SearchResult([], 0));
                            subscriber.complete();
                        });
                    }

                    let result = response.uitstelRequest?.uitstelVerzoekList || [];

                    if (this.clientId != 0) {
                        result = result.filter(a => a.fiscaalNummer === this.taxId);
                    }

                    // --- VOEG DIT TOE: Apply search filter ---
                    if (criteria.searchTerm && criteria.searchTerm.trim() !== '') {
                        const searchLower = criteria.searchTerm.toLowerCase().trim();
                        result = result.filter(item =>
                                item.achternaamBelastingplichtige?.toLowerCase().includes(searchLower) ||
                                item.fiscaalNummer?.toLowerCase().includes(searchLower)

                        );
                    }

                    result = result.sort((a, b) => {
                        const achternaamA = a.achternaamBelastingplichtige?.toLowerCase() || '';
                        const achternaamB = b.achternaamBelastingplichtige?.toLowerCase() || '';
                        return achternaamA.localeCompare(achternaamB);
                    });

                    // --- VOEG DIT TOE: Apply paging ---
                    const start = criteria.skip || 0;
                    const end = start + (criteria.take || 25);
                    const pagedResult = result.slice(start, end);

                    // update data service
                    this.dataService.updateGegevensList(result);

                    return new Observable<SearchResult<UitstelGegevens>>(subscriber => {
                        subscriber.next(new SearchResult(pagedResult, result.length));
                        subscriber.complete();
                    });
                })
            );
        },

      details: (entity) => {
        if (entity.fiscaalNummer != undefined) {
          this.dataService.updateGegevens(entity);
          this.details.next(entity.fiscaalNummer);
        }
      },

      zeroStateConfig: ZeroStateConfiguration.create({
        icon: 'book-open-cover',
        mainText: year < 2024
          ? 'Er zijn geen uitstelverzoeken beschikbaar'
          : year > 2024 ? $localize`De uitstelregeling is nog niet beschikbaar voor ` + year : $localize`Er zijn nog geen uitstelverzoeken voor ` + year,
        subText: year < 2024
          ? 'De uitstelregeling (beconregeling) wordt door SnelStart ondersteund vanaf fiscaal jaar 2024.'
          : 'Je geeft bij een klant via de klantinstellingen aan of de uitstelregeling (beconregeling) van toepassing is. Dit wordt per maart weergegeven in dit uitsteloverzicht.',
      }),
    });
  }
}
